import {NgClass}                            from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {PressHoldDirective}                 from '../../../../../../../logr-services/directives/press-hold.directive';

export interface PanelMenuConfRowIntf {
	uuid: string;
	icon: string;
	text: string[];
	func: () => void;
	active?: () => boolean;
}

@Component({
			   selector   : 'app-menu-crud-tile',
			   imports: [
				   PressHoldDirective,
				   NgClass
			   ],
			   templateUrl: './menu-crud-tile.component.html',
			   styleUrl   : './menu-crud-tile.component.css'
		   })
export class MenuCrudTileComponent {
	conf = input.required<PanelMenuConfRowIntf>()
	toggle = input(booleanAttribute(false), {transform: booleanAttribute});
}
